<template lang="pug">
  v-container
    v-card.pointer( v-if="!loading" v-for="project in projects" :key="project.id" class="mx-auto mb-1 pointer" max-width="400" @click.native="goToProject(project)" )
      v-card-title {{ project.name }}
        v-icon.download-icon( v-if="isMerch" @click.stop="loadAllData(project)" ) mdi-download-circle-outline
      div.archive-info
        span(v-if="projectStatistic[project.id]") Сихронизировано {{ projectStatistic[project.id].synced }} из {{ projectStatistic[project.id].total }}
        span.archive-date(v-if="project.prefetchedAt") Загружено {{ downloadDate(project) }} в {{ downloadTime(project) }}
    v-card( v-if="loading" class="mx-auto" flat max-width="50" )
      v-progress-circular( :size="50" color="primary" indeterminate )
    v-card( v-if="error" class="mx-auto" max-width="400" )
      v-card-title Что-то пошло не по плану
        v-spacer
        v-icon( color="red" ) mdi-alert
      v-card-subtitle {{ error }}
    v-dialog( v-model="loadingReport" width="unset" :persistent="loadingReport" )
      v-card
        v-card-title Загрузка отчетов...
        v-card-text( v-if="loadingReport" )
          v-progress-linear( color="deep-purple accent-4" indeterminate rounded height="6" )
</template>


<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import dataService from "../../../_services/dataService";
import syncService from "../../../_services/syncService";
import { offlineReportService } from "../../../_services/offlineReportService";

export default {
  data: () => ({
    projects:[],
    loading:false,
    error: null,
    projectStatistic: {},
    loadingReport: false
  }),

  mounted() {
    this.loadProjects()
    window.addEventListener('app:online-sync', this.loadProjects)
  },

  beforeDestroy() {
    window.removeEventListener('app:online-sync', this.loadProjects)
  },

  computed: {
    ...mapState("project", ["selectedProject"]),
    ...mapGetters('user', ['checkRole']),

    isMerch() {
      return this.checkRole(1)
    },

  },

  methods: {
    ...mapMutations(['setAppBarTitle']),
    ...mapMutations("project", ["setSelectedProject"]),
    test() {
      syncService.syncAll()
    },

    init() {
      this.loadProjects
    },

    async getProjectStatistic(projects) {
      let statistic = {}
      for(const project of projects) {
        statistic[project.id] = await offlineReportService.getProjectStatistic(project.id)
      }
      this.projectStatistic = statistic
    },

    downloadDate(project) {
      let date = new Date(project.prefetchedAt)
      return date.toLocaleDateString('ru-RU')
    },

    downloadTime(project) {
      let date = new Date(project.prefetchedAt)
      return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
    },
    
    async loadAllData(project) {
      if(dataService.hasUnsyncedReport()) {
        await syncService.syncAll()
      } 
      this.loadingReport = true
      await dataService.prefetchAll(project.id).finally(() => {
        this.loadingReport = false
        this.loadProjects()
      })
    },
    
    async loadProjects(){
      this.loading = true
      this.setAppBarTitle('loading')
      this.projects = []
      await dataService.getProjects()
      .then(data => {
        this.getProjectStatistic(data)
        this.projects = data
        this.loading = false
        this.setAppBarTitle('Проекты')
      })
      .catch(error => {
        this.loading = false
        this.error = error
        this.setAppBarTitle(this.error)
      })
    },

    goToProject(p){
      this.setSelectedProject(p)
      this.$router.push(`/project/${p.id}`)
    }
  }
}
</script>
<style scoped>
.download-icon {
  margin-left: auto !important;
  font-size: 32px;
}
.archive-info {
  font-size: 10px;
  line-height: 22px;
  color: #00000099;
  width: 100%;
  margin-top: -10px;
  display: flex;
  padding: 0 16px 16px 16px;
}
.archive-date {
  margin-left: auto !important;
} 
</style>